/* @flow */

import * as React from 'react';

import GridSelect from 'app/components/commons/GridSelect';
import RectangularButton from 'app/components/commons/RectangularButton';
import { IN_PROGRESS } from 'app/constants/challengeStatusTypes';

type Props = {
  isRacing?: boolean,
  onRef?: HTMLElement => void,
  onSort: string => void,
  sortField: ?string,
  statusId: number
};

const defaultProps = {
  isRacing: false,
  onRef: undefined
};

class PlayerSelectionSortChoice extends React.Component {
  props: Props;

  render() {
    const { isRacing, onRef, onSort, sortField, statusId } = this.props;

    if (isRacing) {
      return (
        <div ref={onRef}>
          {statusId < IN_PROGRESS ? (
            <GridSelect selectedValue={sortField} onSelect={onSort}>
              <RectangularButton value="winProjected">Win</RectangularButton>
              <RectangularButton value="placeProjected">Place</RectangularButton>
              <RectangularButton value="barrier">Barrier</RectangularButton>
              <RectangularButton value="weight">Weight</RectangularButton>
              <RectangularButton value="number">Number</RectangularButton>
            </GridSelect>
          ) : (
            <GridSelect selectedValue={sortField} onSelect={onSort}>
              <RectangularButton value="win">Win</RectangularButton>
              <RectangularButton value="place">Place</RectangularButton>
              <RectangularButton value="popularity">Selected</RectangularButton>
              <RectangularButton value="score">Points</RectangularButton>
            </GridSelect>
          )}
        </div>
      );
    }

    return (
      <div ref={onRef}>
        {statusId < IN_PROGRESS ? (
          <GridSelect selectedValue={sortField} onSelect={onSort}>
            <RectangularButton value="salary">Salary</RectangularButton>
            <RectangularButton value="average">Average</RectangularButton>
            <RectangularButton value="popularity">Selected</RectangularButton>
            <RectangularButton value="form">Form</RectangularButton>
          </GridSelect>
        ) : (
          <GridSelect selectedValue={sortField} onSelect={onSort}>
            <RectangularButton value="salary">Salary</RectangularButton>
            <RectangularButton value="valueForMoney">Value</RectangularButton>
            <RectangularButton value="popularity">Selected</RectangularButton>
            <RectangularButton value="score">Points</RectangularButton>
          </GridSelect>
        )}
      </div>
    );
  }
}

PlayerSelectionSortChoice.defaultProps = defaultProps;

export default PlayerSelectionSortChoice;
